import { resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden" }
const _hoisted_2 = { class: "p-4" }
const _hoisted_3 = { class: "flex items-start" }
const _hoisted_4 = {
  class: "flex-shrink-0",
  "data-test-type-icon-wrapper": ""
}
const _hoisted_5 = { class: "ml-3 w-0 flex-1 pt-0.5" }
const _hoisted_6 = {
  class: "text-sm font-medium text-gray-900",
  "data-test-title": ""
}
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = {
  key: 1,
  class: "mt-4 flex",
  "data-test-buttons-holder": ""
}
const _hoisted_9 = { class: "ml-4 flex-shrink-0 flex" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Close", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_CloseIcon = _resolveComponent("CloseIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.iconComponent), {
            class: _normalizeClass([_ctx.iconDomClasses, "h-6 w-6"])
          }, null, 8, ["class"]))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.title), 1),
          (_ctx.description)
            ? (_openBlock(), _createElementBlock("p", {
                key: 0,
                class: "mt-1 text-sm text-gray-500",
                "data-test-description": "",
                innerHTML: _ctx.description
              }, null, 8, _hoisted_7))
            : _createCommentVNode("", true),
          (_ctx.buttons && _ctx.buttons.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.buttons, (button, buttonIndex) => {
                  return (_openBlock(), _createBlock(_component_AppButton, {
                    key: `toast-button-${buttonIndex}`,
                    type: button.type,
                    size: button.size ?? 'small',
                    class: "cursor-pointer mr-2",
                    onClick: ($event: any) => (_ctx.buttonClick(button))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(button.title), 1)
                    ]),
                    _: 2
                  }, 1032, ["type", "size", "onClick"]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", {
            class: "bg-white rounded-md inline-flex text-gray-400 mt-0.5 hover:text-gray-500 focus:outline-none",
            "data-test-close-button": "",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closeToast')))
          }, [
            _hoisted_10,
            _createVNode(_component_CloseIcon, {
              class: "h-5 w-5",
              "aria-hidden": "true"
            })
          ])
        ])
      ])
    ])
  ]))
}